// ACF Blocks JavaScript
// Import all block-specific scripts

import '../../blocks/double-column-title/double-column-title.js';
import '../../blocks/worth-return/worth-return.js';
